module.exports = __webpack_public_path__ + "assets/64435999a3c0ff07fef0a0d143f2c52e.png";